import React, { createContext, useContext, useState, ReactNode } from 'react';

type HeaderFooterContextType = {
  showHeader: boolean;
  setShowHeader: (value: boolean) => void;
  showFooter: boolean;
  setShowFooter: (value: boolean) => void;
};

const HeaderFooterContext = createContext<HeaderFooterContextType | undefined>(undefined);

export const HeaderFooterProvider = ({ children }: { children: ReactNode }) => {
  const [showHeader, setShowHeader] = useState(true);
  const [showFooter, setShowFooter] = useState(true);

  return (
    <HeaderFooterContext.Provider value={{ showHeader, setShowHeader, showFooter, setShowFooter }}>
      {children}
    </HeaderFooterContext.Provider>
  );
};

export const useHeaderFooter = () => {
  const context = useContext(HeaderFooterContext);
  if (!context) throw new Error('useHeaderFooter must be used within HeaderFooterProvider');
  return context;
};
